import { AppBar, Box, Container, Grid, IconButton, Tab, Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { linear_content_style, linear_h, linear_item, linear_v } from '../../libs/linear-layout/LinearLayout'
import AppBarTabs from '../components/AppBarTabs'
import AppMenuButton from '../components/AppMenuButton'
import { R } from '../R'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import MoreIcon from '@mui/icons-material/MoreVert';
import TabPage from '../components/TabPage'
import HideOnScroll from '../components/HideOnScroll'
import FrmDemo_BlankNote from '../../libs/demo/FrmDemo_BlankNote'

type Props = {}

const FrmBlank = (props: Props) => {

  const MAX_WIDTH = "lg";

  const [AppBarTabIndex, set_AppBarTabIndex] = useState("Tab1");

  // ref: https://stackoverflow.com/questions/56551045/what-is-the-usage-of-material-ui-usescrolltrigger-with-child-target-ref
  // please keep it undefined here to not make useScrollTrigger throw an error on first render 
  const [scrollTarget, setScrollTarget] = useState(undefined);

  const [IsSlideIn, setIsSlideIn] = useState(false);

  return (
    <Box style={linear_content_style} >

      <Grid {...linear_h}>

        <Grid {...linear_item} width={240} bgcolor='#B5CC9B'>
          <Box bgcolor='#B6E1FB' >
            Master Header
          </Box>
          <br />
          <Box bgcolor='#EEFEEB' >
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
            DataRow<br />
          </Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor=''>
          {render_Detail()}
        </Grid>
      </Grid>
    </Box >
  )

  function render_Detail(): React.ReactNode {
    return (<>
      <Grid {...linear_v}>
        <Grid {...linear_item}  >
          {render_AppBar()}
        </Grid>
        <Grid {...linear_item} flex={1}>
          <Box style={linear_content_style} ref={node => {
            if (node) {
              setScrollTarget(node as any);
            }
          }}>
            <Container maxWidth={MAX_WIDTH}>
              <TabPage tab_key={"Tab1"} curr_tab={AppBarTabIndex}>
                <FrmDemo_BlankNote />
              </TabPage>
              <TabPage tab_key={"Tab2"} curr_tab={AppBarTabIndex}>
                {render_Content("Item Two", 10)}
              </TabPage>
              <TabPage tab_key={"Tab3"} curr_tab={AppBarTabIndex}>
                {render_Content("Item Three", 30)}
              </TabPage>
            </Container>
          </Box>
        </Grid>
      </Grid>
    </>
    );
  }

  function render_Content(title: string, demo_text_loop: number) {
    return <>

      <Box sx={{ my: 2 }}>
        {[...new Array(demo_text_loop)]
          .map(
            () => `START: ${title}、${title}、${title}、${title}、${title}、${title}、${title}、${title}、${title}Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`
          )
          .join('\n')}
      </Box>
    </>;
  }



  function render_AppBar() {

    return (
      <>
        <HideOnScroll scrollTarget={scrollTarget} OnChanged={(IsSlideIn) => { setIsSlideIn(IsSlideIn) }}>
          <AppBar position='static' sx={{ bgcolor: R.color.app_bar }}>
            <Toolbar >
              <AppMenuButton label={"表單名稱"} />
              <Box sx={{ flexGrow: 1, }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
              {render_ActionButtons()}
            </Toolbar>
            {render_AppTabs()}
          </AppBar >
        </HideOnScroll>
      </>

    );

  }

  function render_AppTabs() {
    return <Container maxWidth={MAX_WIDTH}>
      <AppBarTabs AppBarTabIndex={AppBarTabIndex} set_AppBarTabIndex={set_AppBarTabIndex}>
        <Tab label="Tab 1" value={"Tab1"} />
        <Tab label="Tab 2" value={"Tab2"} />
        <Tab label="Tab 3" value={"Tab3"} />
      </AppBarTabs>
    </Container>;
  }



  function render_ActionButtons() {
    return (
      <div>
        <IconButton children={<AddCircleIcon />} size="large" aria-label="search" color="inherit" />
        <IconButton children={<EditIcon />} size="large" aria-label="search" color="inherit" />
        <IconButton children={<DeleteIcon />} size="large" aria-label="search" color="inherit" />
        <IconButton children={<PrintIcon />} size="large" aria-label="search" color="inherit" />
        <IconButton children={<MoreIcon />} size="large" aria-label="search" color="inherit" />
      </div>
    );
  }

}

export default FrmBlank


